import type { ComponentProps } from 'react'
import ChatInterface from '@/components/ChatInterface'
import BoardChatPanelV2 from '@/components/ChatInterface/BoardChatPanelV2'

type Props = Pick<ComponentProps<typeof BoardChatPanelV2>,
  'onClose' | 'autoSendMessage' | 'navigationKey' | 'initialMessage'
> & { embedded: boolean }

/** Fabric omits the board chrome (no top bar), so the chat header carries the call controls and the conversation picker. */
export default function SplitBoardChatPanel({ embedded, ...props }: Props) {
  return embedded
    ? <BoardChatPanelV2 {...props} embedded showCallControls />
    : <ChatInterface {...props} context_type="workspace" chatMode="canvas" />
}
